module.exports = __webpack_public_path__ + "static/media/logo-wordmark_rgb_en_qb.67cf1595.png";